export default __webpack_public_path__ + "static/media/1994.3a1f3859.png";